import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization } from 'src/app/classes/organization';
import { SettingsService } from 'src/app/services/settings.service';
import { environment } from 'src/environments/environment';
import Languages from 'src/app/constants/languages'
import { AuthService } from 'src/app/services/auth.service'
import { MessageService } from 'src/app/services/message.service';
import { LocationService } from 'src/app/services/location.service';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit {

  loading = true
  environment = environment
  currentLocale = $localize.locale
  organizations: Organization[] = []
  languages = Languages

  constructor(public activeModal: NgbActiveModal,
    private router: Router,
    private settingsService: SettingsService,
    private authService: AuthService) { }

    ngOnInit() {
      this.settingsService.organizations().subscribe(organizations => {
        this.organizations = organizations
        this.loading = false
      })
    }
  
    changeLanguage(language: string, organizationId: string) {
      this.authService.isSignedIn().subscribe(result => {
        if (result.signed_in && organizationId != localStorage.getItem('organization')) {
          if (confirm($localize`You are switching countries, you will be logged out. Are you sure?`)) {
            this.authService.signout().subscribe(() => {})
          }

          else {
            return
          }
        }
  
        this.authService.organizationById(organizationId).subscribe(result => {
          localStorage.setItem('organization', result.id)
          localStorage.setItem('api_url', result.api_url)
          localStorage.setItem('ws_url', result.ws_url)
          localStorage.removeItem('order')
  
          const platform = Capacitor.getPlatform();
  
          document.cookie = `lang=${language};max-age=${365 * 24 * 60 * 60};path=/`;
          localStorage.setItem('locale', language)// Android/iOS apps remember language this way
  
          if (platform == 'web') {
            window.location.href = `../${language}/${this.router.url}`
          }
          else {
            window.location.href = `../${language}/index.html`
          }
        })
      })
    }
}
